import type { FC } from 'react'
import ShoppingCartProducts from './ShoppingCartProducts'
import Totals from './Totals'
import ProceedToCheckout from '../buttons/ProceedToCheckout'
import SmBreakpoint from '@g4g/ui/src/utility/SmBreakpoint'

const ShoppingCart: FC = () => (
  <div className="flex flex-col grow">
    <Totals />
    <ShoppingCartProducts areRemovable />
    <SmBreakpoint
      max={
        <div className="px-4 h-12">
          <ProceedToCheckout />
        </div>
      }
    />
  </div>
)

export default ShoppingCart
